<mat-chip-grid #chipList [formControl]="chipListCtrl">
  @for (value of chipListCtrl.value; track value; let i = $index) {
    <mat-chip-row (removed)="remove(i)" [value]="value">
      <ng-container>
        {{ getUserDisplayName(value) }}
      </ng-container>
      <a href="#" matChipRemove>
        <mat-icon>cancel</mat-icon>
      </a>
    </mat-chip-row>
  }
  <input
    [formControl]="itemControl"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="add($event)"
  />
</mat-chip-grid>

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
  @for (value of filteredValues$ | async; track value) {
    <mat-option [value]="value">
      {{ value.name }} {{ value.surname }}
      @if (value.username) {
        <span class=""> &lt;{{ value.username }}&gt;</span>
      }
      @if (value.function) {
        <span class="small"><br />{{ 'SHARED.USER_SELECT.OCCUPATION' | translate }} {{ value.function }}</span>
      }
    </mat-option>
  }
</mat-autocomplete>
